import { ContextWrapper } from "@common/contexts";
import { useApp } from "@common/hooks/useApp";
import { ClientConfigurationModel } from "@common/models";
import { PetDetailsStore } from "@common/stores";
import React, { useContext, useEffect, useMemo, useState } from "react";

export const PetDetailsStoreContext = new ContextWrapper<PetDetailsStore>();

/**
 * Create a pet details store
 * @param configuration the configuration client model instance, you can get this from prop drilling in Routes, or by using the useApp hook to return the appStore and current Configuration object
 * @returns
 */
export const useCreatePetDetailsStore = (configuration: ClientConfigurationModel, options?: { shouldSetContext?: boolean }) => {
	const [shouldSetContext, setShouldSetContext] = useState<boolean>(Boolean(options?.shouldSetContext));

	useEffect(() => {
		if (options)
			setShouldSetContext(Boolean(options.shouldSetContext));
	}, [options])

	const [petDetailsStore] = useMemo(() => {
		const store = new PetDetailsStore({ configuration });
		if (shouldSetContext)
			PetDetailsStoreContext.set(store);
		return [store];
	}, [configuration, shouldSetContext])
	return petDetailsStore;
}

//will return a new pet details store if context has not been set.
export const usePetDetailsStore = () => {
	const { configuration } = useApp();
	return useContext(PetDetailsStoreContext.get() ?? React.createContext(new PetDetailsStore({ configuration })));
}
